import { render } from "./dayOff.vue?vue&type=template&id=7459ee30"
import script from "./dayOff.vue?vue&type=script&lang=js"
export * from "./dayOff.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Git\\VueTemplate\\A1Catering\\a1cateringadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__